/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Settings_External_Dirs_DescriptionInputs */

const es_walkthrough_settings_external_dirs_description = /** @type {(inputs: Walkthrough_Settings_External_Dirs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acá se visualizan las carpetas externas sincronizadas. Podés activar o desactivar la sincronización automática de cada carpeta, o eliminarla de Nexata junto con todo su contenido.`)
};

const en_walkthrough_settings_external_dirs_description = /** @type {(inputs: Walkthrough_Settings_External_Dirs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here you can see your synced external folders. You can enable or disable auto-sync for each folder, or remove it from Nexata along with all its content.`)
};

/**
* | output |
* | --- |
* | "Here you can see your synced external folders. You can enable or disable auto-sync for each folder, or remove it from Nexata along with all its content." |
*
* @param {Walkthrough_Settings_External_Dirs_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_settings_external_dirs_description = /** @type {((inputs?: Walkthrough_Settings_External_Dirs_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Settings_External_Dirs_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_settings_external_dirs_description(inputs)
	return en_walkthrough_settings_external_dirs_description(inputs)
});
export { walkthrough_settings_external_dirs_description as "walkthrough.settings_external_dirs_description" }